import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-integer";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { validatePhone, validateEmail, validatePwd } from "@/util/validate";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "treeForm",
  props: {},
  computed: _objectSpread({}, mapGetters(["dialogVisible", "status", "dialogTitle", "formData", "labelWidth", "radioArray", "lableArray"])),
  data: function data() {
    var validateNumber = function validateNumber(rule, value, callback) {
      console.log("数字验证:", value);

      if (value !== 0) {
        if (!value) {
          return callback(new Error("请输入内容"));
        }
      }

      setTimeout(function () {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }, 1000);
    };

    var validateText = function validateText(rule, value, callback) {
      console.log("文本验证:", value);

      if (!value) {
        callback(new Error("请输入内容"));
      } else {
        callback();
      }
    };

    return {
      rules: _defineProperty({
        id: [{
          validator: validateNumber,
          trigger: "blur"
        }],
        hieName: [{
          validator: validateText,
          trigger: "blur"
        }],
        target: [{
          validator: validateText,
          trigger: "blur"
        }]
      }, "target", [{
        validator: validateText,
        trigger: "blur"
      }]),
      defaltValue: "",
      childValidateRules: []
    };
  },
  watch: {
    dialogVisible: function dialogVisible() {
      console.log(777, this.formData);
    } //   rowData(val) {
    //   },
    //   compositeData: {
    //     handler: function (val) {
    //     },
    //     deep: true,
    //     immediate: true
    //   },
    //   formData: {
    //     handler: function (val) {
    //       this.$nextTick(() => {
    //         if (this.compositeData && Object.keys(val).includes('lev') && Object.keys(val).includes('priv_f_no')) {
    //           try {
    //             this.compositeData.p_priv_f_no.data.forEach(item => {
    //               if (val.p_priv_f_no === item.value) {
    //                 this.formData.lev = item.lev + 1
    //                 throw  new Error("EndIterative")
    //               }
    //             })
    //           } catch (e) {
    //             if (e.message != "EndIterative") throw  e
    //           }
    //         }
    //       })
    //     },
    //     deep: true,
    //     immediate: true
    //   },

  },
  created: function created() {
    console.log(111, this.radioArray);
  },
  methods: _objectSpread(_objectSpread({}, mapActions(["closeDialog", "submitForm"])), {}, {
    handleClose: function handleClose() {
      this.closeDialog();
    },
    //   showDialog(flag, validateRules, lableArray) {
    //     this.editFlag = flag
    //     this.childValidateRules = validateRules
    //     this.$nextTick(() => {
    //       Object.keys(this.formData).forEach((item, index) => {
    //         if (flag === 'edit') {
    //           this.formData[item] = this.rowData[item]
    //         }
    //         if (flag === 'add') {
    //           this.formData[item] = index === 0 ? 0 : ''
    //         }
    //         if (validateRules[index] === 'number') {
    //           this.rules[item] = [
    //             {validator: this.validateNumber, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'text') {
    //           this.rules[item] = [
    //             {validator: this.validateText, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'email') {
    //           this.rules[item] = [
    //             {validator: this.validateEmailText, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'phone') {
    //           this.rules[item] = [
    //             {validator: this.validateTelphone, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'password') {
    //           this.rules[item] = [
    //             {validator: this.validatePassword, trigger: 'blur'}
    //           ]
    //         }
    //       })
    //       this.lableArray = lableArray
    //       this.$refs.formData && this.$refs.formData.clearValidate()
    //       this.dialogVisible = true
    //     })
    //   },
    handleSubmit: function handleSubmit(formName) {
      this.$nextTick(function () {
        var _this = this;

        this.$refs.formData.validate(function (valid) {
          console.log("验证结果：", valid);

          if (valid) {
            // this.$emit('submitEditData', this.formData)
            _this.submitForm(_this.formData).then(function (res) {
              console.log("提交表单结果：", res);

              _this.$message.closeAll();

              _this.$message({
                message: "恭喜你，操作成功",
                type: "success"
              });
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    resetForm: function resetForm(formName) {
      if (this.$refs.formData !== undefined) {// this.$refs.formData.resetFields()
        // Object.keys(this.formData).forEach((item, index) => {
        //   !this.forbidClearFild.includes(item)&&(this.formData[item] = '')
        // })
        // if (this.editFlag === 'add') {
        //   this.formData[Object.keys(this.formData)[0]] = 0
        // }
      }
    }
  })
};